import { map } from 'rxjs';
import { isPWA } from '../utils/detect';
export const pwaRequestInterceptor = () => map((config) => {
    if (isPWA())
        config.headers['X-PWA'] = '1';
    return config;
});
//# sourceMappingURL=pwaRequestInterceptor.js.map